import styled from "styled-components";
import { StyledCard } from "./interface";

export const PerspectiveContainer = styled.div`
    width: 100%;
    height: 100%;
    margin-top: 10px;
`;

export const PerspectiveCard = styled.div<StyledCard>`
    height: auto;
    min-height: 150px;
    color: white;
    background-color: ${(props) => props.color };
    margin: 10px 0 10px;
    padding: 5px 5px 0 5px;
    display: grid;
    position: relative;
    border-radius: 5px;

    .card-options{
        display: ${(props) => props.inEditCauseEffect ? "none !important" : "block" };
    }

    &:hover{
        .card-options{
            display: flex;
        }
    }

    .card-options{
        display: none;
        flex-wrap: wrap;
        position: absolute;
        top: -22px;
        left: 4px;
        z-index: 1;

        button{
            background-color: ${(props) => props.color };
            border: 1px solid white;
        }

        span._component_tooltip-span{
            background-color: ${(props) => props.color };
            border: 1px solid white;
        }

        div._component-popover{
            background: #fff;
            div{
                background: ${(props) => props.color };
            }
            
        }
    }

    .card-header{
        display: flex;
        justify-content: space-between;
        margin-top: 5px;

        span{
            display: flex;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
`;

export default PerspectiveContainer;
